import React from 'react';

import { CircularProgress } from '@mui/material';

import { ICON_SIZE_PX } from '../../../../constants/buttons';
import { CONTROLLER_ON, WHITE } from '../../../../constants/colors';
import { IBdsIconButton } from '../../../../interfaces/buttons';

import './BdsIconButton.scss';

const customStyles = {
  customLoadingWhite: {
    color: WHITE
  },
  customLoadingBlack: {
    color: CONTROLLER_ON
  }
};

const BdsIconButton = ({
  icon,
  action,
  disabled,
  loading,
  variant,
  size,
  label,
  className,
  onMouseEnter,
  onMouseLeave
}: IBdsIconButton) => {
  const classNames = ['circular-icon-button', variant, size, loading ? 'loading' : '', className].join(' ');

  const spinnerStyle = {
    primary: customStyles.customLoadingWhite,
    secondary: customStyles.customLoadingBlack,
    transparent: customStyles.customLoadingBlack,
    inverse: customStyles.customLoadingBlack,
    'transparent-inverse': customStyles.customLoadingWhite,
    'secondary-inverse': customStyles.customLoadingWhite
  };

  return (
    <button
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      disabled={loading || disabled}
      aria-label={label}
      className={classNames}
      onClick={action}
    >
      {loading && <CircularProgress sx={{ ...spinnerStyle[variant] }} size={ICON_SIZE_PX[size]} />}
      {!loading && icon && <icon.component />}
    </button>
  );
};

export default BdsIconButton;
